"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgEmployeeIssues = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 33, height: 32, fill: "none" }, props),
    React.createElement("path", { stroke: "#8B93A6", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M27.435 1.656 24.81 4.281l1.313 1.968-2.625 1.97M5.498 1.656l2.625 2.625L6.81 6.25l2.625 1.97M16.936 1l-1.312 1.968 1.312 1.313" }),
    React.createElement("path", { fill: "#D9EAF5", d: "M25.433 32c0-2.652-.949-5.196-2.636-7.071S18.82 22 16.433 22s-4.676 1.054-6.364 2.929S7.433 29.348 7.433 32" }),
    React.createElement("path", { stroke: "#4A6AA1", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M25.434 31a9 9 0 0 0-18 0" }),
    React.createElement("path", { fill: "#D9EAF5", d: "M12.937 9.25c1.29 1.336-2.75 3.5 3.79 4.383 1.82.366 6.837.867 3.149-3.633" }),
    React.createElement("path", { stroke: "#4A6AA1", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M11.7 11.708a9.14 9.14 0 0 0 10.19 2.048" }),
    React.createElement("path", { stroke: "#4A6AA1", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M16.436 20a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M16.436 22v5" })));
exports.default = SvgEmployeeIssues;
